import React, { useEffect, useState } from "react";
import { Form } from "react-final-form";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import useAutosave from "src/hooks/useAutosave";
import { IRootState } from "src/store/reducers";
import {
  fetchApplicationGMEGSIDetails,
  saveAppDetailGME,
  saveAppDetailGSI,
} from "src/store/reducers/applicationGmeGsi";
import { TabProps } from "../../pages";
import GMEDetails from "./GMEDetails/GMEDetails";
import GSIDetails from "./GSIDetails/GSIDetails";

export const AppGMEGSIDetail = (props: TabProps) => {
  const { id: applicationId } = useParams<{ id: string }>();
  const dispatch = useDispatch();
  const [formRef, setFormRef] = useState(null);

  const { userID, gmeGsiDetails } = useSelector((state: IRootState) => ({
    userID: state.auth.user.userID,
    gmeGsiDetails: state.applicationGmeGsi.gmeGsiDetails,
  }));
  const {
    SelectedGMESchools,
    SelectedGSIGroups,
    AvailableGMESchools,
    AvailableGSIGroups,
    ApplicationGMESchool,
    ApplicationGSIGroup,
  } = gmeGsiDetails;

  useEffect(() => {
    dispatch(fetchApplicationGMEGSIDetails(applicationId));
  }, [dispatch, applicationId]);

  const performSave = async () => {
    if (!formRef) return;
    const state = formRef.getState();
    const { school, group } = state.values;

    const selectedSchool = SelectedGMESchools.find(s => s.gid === school);
    const selectedGroup = SelectedGSIGroups.find(g => g.gid === group);

    const applicationSchool = ApplicationGMESchool?.[0];
    const applicationGroup = ApplicationGSIGroup?.[0];

    try {
      if (selectedSchool) {
        await dispatch(
          saveAppDetailGME(+applicationId, userID, {
            ...selectedSchool,
            id: applicationSchool?.id ?? 0, // existing appGME id for edit
          }),
        );
      }

      if (selectedGroup) {
        await dispatch(
          saveAppDetailGSI(+applicationId, userID, {
            ...selectedGroup,
            id: applicationGroup?.id ?? 0, // existing appGSI id for edit
          }),
        );
      }

      await dispatch(fetchApplicationGMEGSIDetails(applicationId));
    } catch (err) {}
  };

  const AutoSave = useAutosave(props, performSave);

  return (
    <Form
      onSubmit={performSave}
      initialValues={{
        school: ApplicationGMESchool[0]?.gid || "",
        group: ApplicationGSIGroup[0]?.gid || "",
      }}>
      {({ form, dirty }) => {
        if (!formRef) setFormRef(form);

        useEffect(() => {
          props.onDirty(dirty);
        }, [dirty]);

        return (
          <form onSubmit={form.submit} className="app-gme-gsi__container">
            <GMEDetails
              selectedSchools={SelectedGMESchools}
              availableSchools={AvailableGMESchools}
              applicationId={applicationId}
            />
            <GSIDetails
              selectedGroups={SelectedGSIGroups}
              availableGroups={AvailableGSIGroups}
              applicationId={applicationId}
            />

            <AutoSave />
          </form>
        );
      }}
    </Form>
  );
};
